import Api from "./Api.js";
import { getBaseUrl } from "./ApiHelper.js";
import qs from "qs";

const resource = "/orders";

export default {
  get(filters) {
    // clean up the supplied filters
    // first we need to remove any "empty" values
    filters = JSON.parse(JSON.stringify(filters), (key, value) => {
      if (
        value == null ||
        value === "" ||
        value === [] ||
        value === {} ||
        key === "newSearch"
      )
        return undefined;
      return value;
    });

    // then we need to remove any leftover "empty" objects
    Object.keys(filters).forEach(key => {
      if (typeof filters[key] == "object" && Object.keys(filters[key]) === 0)
        delete filters[key];
    });

    return Api.get(`${resource}`, {
      params: filters,
      paramsSerializer: filters => {
        return qs.stringify(filters, {
          // arrayFormat: 'indicies', // 'a[0]=b&a[1]=c'
          arrayFormat: "brackets", // 'a[]=b&a[]=c' (laravel standard)
          // arrayFormat: 'comma', // 'a=b,c'
          // arrayFormat: 'repeat', // 'a=b&a=c' (mocks)
          encode: false
        });
      }
    });
  },

  getOrder(OrderNumber) {
    return Api.get(`${resource}/${OrderNumber}`);
  },

  getOverview() {
    return Api.get(`${resource}/overview`);
  },

  getTracking(OrderNumber) {
    return Api.get(`${resource}/${OrderNumber}/tracking`);
  },

  getDiscounts(OrderNumber) {
    return Api.get(`${resource}/${OrderNumber}/discounts`);
  },

  getTransactions(OrderNumber) {
    return Api.get(`${resource}/${OrderNumber}/transactions`);
  },

  patchOrder(OrderNumber, data) {
    return Api.patch(`${resource}/${OrderNumber}`, data);
  },

  holdOrder(OrderNumber, data) {
    return Api.patch(`${resource}/${OrderNumber}/hold`, data);
  },

  releaseOrder(OrderNumber, data) {
    return Api.patch(`${resource}/${OrderNumber}/release`, data);
  },
  rejectOrders(data) {
    return Api.patch(`${resource}/reject-orders`, data);
  },

  cancelOrder(OrderNumber, data) {
    return Api.patch(`${resource}/${OrderNumber}/cancel`, data);
  },

  adjustOrder(OrderNumber, data) {
    return Api.patch(`${resource}/${OrderNumber}/adjust`, data);
  },

  getWarrantableValue(OrderNumber) {
    return Api.get(`${resource}/${OrderNumber}/warranties/value`);
  },

  createWarranty(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/warranties`, data);
  },

  claimWarranty(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/claims/warranty`, data);
  },

  claimGuarantee(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/claims/guarantee`, data);
  },

  claimDormancy(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/claims/dormancy`, data);
  },

  claimException(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/claims/exception`, data);
  },

  getRefundValue(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/claims/refund/value`, data);
  },

  editOrderProducts(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/products`, data);
  },

  editOrderExpectedShipDate(OrderNumber, data) {
    return Api.put(`${resource}/${OrderNumber}/expected-ship-date`, data);
  },

  editOrderProductsESD(OrderNumber, data) {
    return Api.post(
      `${resource}/${OrderNumber}/products/edit-expected-ship-date`,
      data
    );
  },

  reviseItem(OrderNumber, ItemNumber, data) {
    return Api.put(
      `${resource}/${OrderNumber}/items/${ItemNumber}/revise`,
      data
    );
  },

  changeFacility(OrderNumber, ItemNumber, data) {
    return Api.post(
      `${resource}/${OrderNumber}/items/${ItemNumber}/change-facility`,
      data
    );
  },

  fillBackorders(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/backorders/fill`, data);
  },

  forceBackorders(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/backorders/force`, data);
  },

  addTracking(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/tracking`, data);
  },

  updatePrintDates(OrderNumber, data) {
    return Api.patch(`${resource}/${OrderNumber}/items/print-date`, data);
  },

  unsubscribeCustomer(OrderNumber) {
    return Api.delete(`${resource}/${OrderNumber}/customers/subscription`);
  },

  updateOrderFulfillmentStatus(OrderNumber) {
    return Api.patch(`${resource}/${OrderNumber}/fulfillment-status`);
  },

  updateIgnoreFraudScore(OrderNumber, ignoreFraudScore) {
    return Api.put(`${resource}/${OrderNumber}/ignore-fraud-score`, {
      "ignore-fraud-score": ignoreFraudScore
    });
  },

  validateAddress(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/validate-address`, data);
  },

  /************************************************************************
   *                        Customer Care API v2                          *
   ************************************************************************/
  checkStateRestrictions(OrderNumber) {
    return Api.get(`${resource}/${OrderNumber}/state-restrictions`, {
      baseURL: getBaseUrl("v2")
    });
  },
  enforceStateRestrictions(OrderNumber) {
    return Api.post(
      `${resource}/${OrderNumber}/enforce-state-restrictions`,
      null,
      {
        baseURL: getBaseUrl("v2")
      }
    );
  },
  shopifyDetails(sourceOrderNumber) {
    return Api.get(`${resource}/${sourceOrderNumber}/shopify-details`, {
      baseURL: getBaseUrl("v2")
    });
  },
  getCalculatedRefund(OrderNumber, data) {
    return Api.post(`${resource}/${OrderNumber}/claims/refund/value`, data, {
      baseURL: getBaseUrl("v2")
    });
  },
  adjustOrderV2(OrderNumber, data) {
    return Api.patch(`${resource}/${OrderNumber}/adjust`, data, {
      baseURL: getBaseUrl("v2")
    });
  },

};
